import React from "react";
import Subheading from "../Common/Subheading";
import HelpButton from "../HelpContent/HelpButton";
import BillingDetailsIcon from "../../assets/icons/invoice_history.svg2";
import CreateSolutionModal from "../Library/CreateSolutionModal";
import { Col, Row } from "react-bootstrap";

export default function SystemAdminSettings({ editedSolution }) {
  return (
    <div>
      <Subheading
        Icon={BillingDetailsIcon}
        heading="System Admin Settings"
        subheading="Your pre-defined System Admin settings"
      />
      <Row xs={1} xl={2}>
        <Col>
          <CreateSolutionModal editedSolution={editedSolution} />
        </Col>
      </Row>
    </div>
  );
}
